import React, { useState } from 'react';
import './Header.css';
import logoSxc from '../img/logosxc.png';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="container-fluid bg-light position-relative shadow">
      <nav className="navbar navbar-expand-lg bg-light navbar-light py-2 py-lg-0 px-3 px-lg-5">
        <a href="#home" className="navbar-brand text-secondary d-flex align-items-center flex-shrink-0" style={{textDecoration:'none'}} onClick={closeMenu}>
          <img
            src={logoSxc}
            alt="St. Francis Xavier logo"
            style={{height:80, width:'auto', marginRight:12, borderRadius:6, objectFit:'contain'}}
          />
          <div style={{display:'flex', flexDirection:'column', lineHeight:'1.1', minWidth:0}}>
            <span style={{fontSize:'2.5rem', fontWeight:700, color:'#00394f', fontFamily:"'Playfair Display', serif", wordBreak:'break-word'}}>St. Francis Xavier School</span>
            <small style={{fontSize:'0.75rem', color:'#17a2b8', marginTop:2, fontFamily:"'Nunito', sans-serif"}}>Tuticorin</small>
          </div>
        </a>
        <button
          type="button"
          className="navbar-toggler ms-auto"
          onClick={toggleMenu}
          style={{order: 3}}
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse justify-content-end ${isOpen ? 'show' : ''}`} id="navbarCollapse">
          <div className="navbar-nav font-weight-bold py-0">
            <a href="#home" className="nav-item nav-link active" onClick={closeMenu}>Home</a>
            <a href="#about" className="nav-item nav-link" onClick={closeMenu}>About</a>
           {/*} <a href="#classes" className="nav-item nav-link" onClick={closeMenu}>Classes</a>
            <a href="#team" className="nav-item nav-link" onClick={closeMenu}>Teachers</a>*/}
            <a href="#gallery" className="nav-item nav-link" onClick={closeMenu}>Gallery</a>
            <a href="#contact" className="nav-item nav-link" onClick={closeMenu}>Contact</a>
          </div>
       {/*}   <a href="#contact" className="btn btn-primary px-4">Enroll Now</a> */}
        </div>
      </nav>
    </div>
  );
}
